var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9021 12.5486C23.2367 12.5486 23.5191 12.6689 23.7492 12.9094C23.9479 13.1185 24.042 13.3931 24.0315 13.7329C24.0211 14.0728 23.9113 14.3526 23.7022 14.5722L17.5375 21.1134C17.2656 21.4062 16.9414 21.6023 16.5649 21.7016C16.1884 21.801 15.8119 21.801 15.4355 21.7016C15.059 21.6023 14.7348 21.4062 14.4629 21.1134L8.31389 14.5722C8.08383 14.3317 7.96357 14.052 7.9531 13.7329C7.94265 13.414 8.04723 13.1448 8.26683 12.9252C8.48644 12.6846 8.76356 12.5591 9.0982 12.5486C9.43284 12.5383 9.7152 12.6533 9.94527 12.8938L16.0002 19.3408L22.0707 12.8938C22.2903 12.6637 22.5674 12.5486 22.9021 12.5486Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonMore);
export default __webpack_public_path__ + "static/media/button-more.1bd5524837482cd4e71bb2a658289dfd.svg";
export { ForwardRef as ReactComponent };